export const AUTH_NAME = 'auth';
